export const handleUpdateGroup = async (object) => {
    let res = await fetch(process.env.REACT_APP_SERVER_LINK+"updateGroup", {
        method:"PUT",
        body:JSON.stringify(object),
        headers: {
            'Content-Type': 'application/json'
        },
    });
    let json = await res.json();
    return json;
}

export const handleCreateGroup = async (object) => {
    let res = await fetch(process.env.REACT_APP_SERVER_LINK+"createGroup", {
        method:"POST",
        body:JSON.stringify(object),
        headers: {
            'Content-Type': 'application/json'
        },
    });
    let json = await res.json();
    return json;
}

export const handleDeleteGroup = async (object) => {
    let res = await fetch(process.env.REACT_APP_SERVER_LINK+"deleteGroup?token="+object.token+"&groupid="+object.groupid, {
        method:"DELETE",
        body:JSON.stringify(object),
        headers: {
            'Content-Type': 'application/json'
        },
    });
    let json = await res.json();
    return json;
}